module.exports = __webpack_public_path__ + "img/Screenshot_20230817_123725_Viber.48bd415c.jpg";